export default {
  confirm: '确定',
  cancel: '取消',
  add: '新增',
  edit: '编辑',
  save: '保存',
  delete: '删除',
  search: '搜索',
  reset: '重置',
  query: '查询',
};
